import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';

import { LetModule, MediaScreenService } from '@hglobal/common';
import { map } from 'rxjs';

const MEDIA_QUERY = 1440;

@Component({
  imports: [RouterLink, AsyncPipe, LetModule],
  selector: 'pp-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoComponent {
  readonly #mediaScreenService = inject(MediaScreenService);

  // eslint-disable-next-line @typescript-eslint/member-ordering
  logo$ = this.#mediaScreenService
    .mediaMatcher(MEDIA_QUERY)
    .pipe(map((isDesktop: boolean) => (isDesktop ? 'assets/icons.svg#old-logo' : 'assets/icons.svg#logo-small')));
}
